import {
  ContentDetailMetricsContentType,
  ContentDetailMetricsItemType,
} from '.';

export const getValue = <
  C extends ContentDetailMetricsContentType,
  M extends ContentDetailMetricsItemType<C>,
  K extends keyof M,
>(
  content: C,
  metric: M[K],
  metricKey: any,
) => {
  let value: any;

  if (metric?.value) {
    value = metric.value(content);
  } else {
    value = content[metricKey as keyof C];
  }

  if (value && metric?.transformValue) {
    value = metric.transformValue(value);
  }

  return value;
};
